module.exports = __webpack_public_path__ + "img/Levante_DosEnUno R75.aac8d8d6.png";